<template>
  <div class="col">
    <div id="main" class="col-main">
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title">
                Ealing Trailfinders Cricket Club Coaches
              </h2>
            </div>

            <div class="col-12 col-lg-9">
              <!-- Text -->
              <p class="h5">
                The Management Committee is responsible for overseeing the
                administration of the club and its development. They also look
                after the adult and Junior cricket as well as all the
                development and finance of the club.
              </p>
              <br />

              <p class="h5">
                Ealing Trailfinders Cricket Club is managed in accordance with
                the club’s Constitution. The Management Committee and adult team
                captains are elected by the members at our Annual General
                Meeting when reports on the year, including the annual accounts,
                are presented.
              </p>
            </div>

            <div class="col-12 col-lg-9">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <!-- <h4 class="my-4">The Coaches consists of:</h4> -->

                  <!-- <div v-for="coach in coaches"
                                         v-bind:key="coach._id"
                                         class="row no-gutters bg-light mb-4 has-hover-s1"> -->

                  <!-- image -->
                  <!-- <div class="col-6 col-sm-5 m-auto col-md-3 m-md-0 p-3">
                                            <figure class="avatar bg-white">
                                                <b-img-lazy v-if="coach.image"
                                                     :src="coach.image"
                                                     alt="profile_image"
                                                     class=""/>
                                                <b-img-lazy v-else
                                                     src=""
                                                     alt="profile_image"
                                                     class=""/>
                                            </figure>
                                        </div> -->

                  <!-- text -->
                  <!-- <div class="col-12 col-md-9 p-3">
                                            <div class="card bg-transparent">
                                                <div class="card-body p-0">
                                                    <ul class="list-unstyled">
                                                        <li><h5 class="mt-3 m-0">{{coach.coach_name}}</h5></li>
                                                        <li><h6 class="text-normal">{{coach.title}}</h6></li>
                                                        <li>
                                                            <nav class="nav justify-content-start">
                                                                <a class="btn btn-more btn-more-outline btn-more-sm py-3 px-1"
                                                                   v-bind:href="coach.email"><i class="material-icons">email</i></a>
                                                                <a v-if="coach.contact_number"
                                                                   class="btn btn-more btn-more-outline btn-more-sm py-3 px-1"
                                                                   v-bind:href="'tel:' + coach.contact_number"><i class="material-icons">call</i></a>
                                                            </nav>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div> -->

                  <!-- </div> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchCoaches } from "@/services/api";

export default {
  data() {
    return {
      coaches: [],
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      fetchCoaches().then((response) => {
        this.coaches = response;
      });
    },
  },
};
</script>
